interface TelegramLogoProps {
  className?: string;
}

const TelegramLogo = ({ className }: TelegramLogoProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 16"
      fill="currentColor"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill=""
        d="M1.32723 6.8879C6.50982 4.62993 9.9657 3.14134 11.6949 2.42212C16.6319 0.368619 17.6578 0.0119045 18.3265 0.00012559C18.4735 -0.00246506 18.8024 0.0339819 19.0154 0.206816C19.1952 0.352754 19.2447 0.549895 19.2684 0.68826C19.2921 0.826626 19.3216 1.14183 19.2981 1.38811C19.0306 4.1992 17.8729 11.021 17.284 14.1694C17.0348 15.5017 16.5441 15.9484 16.069 15.9921C15.0366 16.0871 14.2527 15.3098 13.2528 14.6543C11.6881 13.6287 10.8041 12.9902 9.28535 11.9893C7.53012 10.8327 8.66796 10.1969 9.66826 9.15799C9.93004 8.8861 14.4788 4.74868 14.5668 4.37335C14.5778 4.32641 14.588 4.15143 14.4841 4.05904C14.3801 3.96664 14.2267 3.99824 14.116 4.02337C13.9591 4.05898 11.4595 5.71112 6.61724 8.97978C5.90774 9.46697 5.26509 9.70435 4.68931 9.69191C4.05455 9.6782 2.83352 9.33301 1.92582 9.03795C0.812484 8.67605 -0.072374 8.48471 0.00467723 7.87009C0.0448103 7.54996 0.485663 7.22256 1.32723 6.8879Z"
      />
    </svg>
  );
};

export default TelegramLogo;
